var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-inline" },
    [
      _c(
        "div",
        {
          staticClass: "ma-0 pa-0 d-inline",
          on: {
            click: function ($event) {
              _vm.openModal = true
            },
          },
        },
        [
          _vm._t("default", function () {
            return [
              _vm.edit
                ? _c(
                    "b-button",
                    { attrs: { variant: "success", block: "" } },
                    [
                      _c("b-icon", { attrs: { icon: "pencil" } }),
                      _vm._v(" Edit Company "),
                    ],
                    1
                  )
                : _c(
                    "b-button",
                    { attrs: { variant: "success", block: "" } },
                    [
                      _c("b-icon", { attrs: { icon: "plus" } }),
                      _vm._v(" Add Company "),
                    ],
                    1
                  ),
            ]
          }),
        ],
        2
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "addcompany",
            title: _vm.edit ? "Edit Company" : "Add Company",
            "ok-variant": "primary",
            busy: _vm.loading,
            "ok-disabled": _vm.isSaveDisabled,
            size: "lg",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
          },
          on: {
            hidden: function ($event) {
              return _vm.reset()
            },
            shown: function ($event) {
              return _vm.init()
            },
            ok: _vm.createCompany,
          },
          scopedSlots: _vm._u([
            {
              key: "modal-ok",
              fn: function () {
                return [
                  _c("b-icon", { attrs: { icon: "check" } }),
                  _vm._v(" Save "),
                ]
              },
              proxy: true,
            },
            {
              key: "modal-cancel",
              fn: function () {
                return [
                  _c("b-icon", { attrs: { icon: "x" } }),
                  _vm._v(" Cancel "),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.openModal,
            callback: function ($$v) {
              _vm.openModal = $$v
            },
            expression: "openModal",
          },
        },
        [
          _c(
            "b-overlay",
            { attrs: { show: _vm.loading } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12", lg: "6" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Name *",
                                    "label-align": "left",
                                  },
                                },
                                [
                                  _c("b-input", {
                                    model: {
                                      value: _vm.company.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.company, "name", $$v)
                                      },
                                      expression: "company.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        { staticClass: "mb-3" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("OrganizationTypeAhead", {
                                attrs: {
                                  selectedOrganizationId:
                                    _vm.company.organization_id,
                                },
                                on: {
                                  selection: _vm.setOrganization,
                                  newEntry: _vm.setOrganization,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Industry",
                                    "label-align": "left",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.industries,
                                      "text-field": "name",
                                      "value-field": "id",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.resetBucket()
                                      },
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "first",
                                        fn: function () {
                                          return [
                                            _c(
                                              "b-select-option",
                                              { attrs: { value: null } },
                                              [_vm._v("-- Select One --")]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.company.industry_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.company,
                                          "industry_id",
                                          $$v
                                        )
                                      },
                                      expression: "company.industry_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Industry Revenue Bucket",
                                    "label-align": "left",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: { options: _vm.bucketsForIndustry },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "first",
                                        fn: function () {
                                          return [
                                            _c(
                                              "b-select-option",
                                              { attrs: { value: null } },
                                              [_vm._v("-- Select One --")]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value:
                                        _vm.company.industryrevenuebucket_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.company,
                                          "industryrevenuebucket_id",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "company.industryrevenuebucket_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Company Status",
                                    "label-align": "left",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.statuses,
                                      "text-field": "name",
                                      "value-field": "id",
                                    },
                                    model: {
                                      value: _vm.company.companystatus_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.company,
                                          "companystatus_id",
                                          $$v
                                        )
                                      },
                                      expression: "company.companystatus_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12", lg: "6" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Bookkeeper",
                                    "label-align": "left",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.bookkeepers,
                                      "value-field": "id",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "first",
                                        fn: function () {
                                          return [
                                            _c(
                                              "b-select-option",
                                              { attrs: { value: null } },
                                              [_vm._v("-- Select One --")]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.company.bookkeeper_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.company,
                                          "bookkeeper_id",
                                          $$v
                                        )
                                      },
                                      expression: "company.bookkeeper_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Data Entry",
                                    "label-align": "left",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.dataentry,
                                      "value-field": "id",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "first",
                                        fn: function () {
                                          return [
                                            _c(
                                              "b-select-option",
                                              { attrs: { value: null } },
                                              [_vm._v("-- Select One --")]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.company.dataentry_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.company,
                                          "dataentry_id",
                                          $$v
                                        )
                                      },
                                      expression: "company.dataentry_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Frequency",
                                    "label-align": "left",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.frequencies,
                                      "text-field": "type",
                                      "value-field": "id",
                                    },
                                    model: {
                                      value: _vm.company.companytype_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.company,
                                          "companytype_id",
                                          $$v
                                        )
                                      },
                                      expression: "company.companytype_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Priority",
                                    "label-align": "left",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.priorities,
                                      "text-field": "name",
                                      "value-field": "id",
                                    },
                                    on: { change: _vm.setDayOfMonth },
                                    model: {
                                      value: _vm.company.companypriority_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.company,
                                          "companypriority_id",
                                          $$v
                                        )
                                      },
                                      expression: "company.companypriority_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Day of month Tickets Due",
                                    "label-align": "left",
                                    description:
                                      "Please make this between 2 and 28",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "number",
                                      min: "2",
                                      max: "28",
                                      onkeypress:
                                        "return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57",
                                    },
                                    model: {
                                      value: _vm.company.defaultdue,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.company, "defaultdue", $$v)
                                      },
                                      expression: "company.defaultdue",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-checkbox",
                        {
                          attrs: { value: 0, "unchecked-value": 1 },
                          model: {
                            value: _vm.company.active,
                            callback: function ($$v) {
                              _vm.$set(_vm.company, "active", $$v)
                            },
                            expression: "company.active",
                          },
                        },
                        [_vm._v(" Disable Company ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("hr"),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Address Line 1",
                            "label-align": "left",
                          },
                        },
                        [
                          _c("b-input", {
                            model: {
                              value: _vm.address.address1,
                              callback: function ($$v) {
                                _vm.$set(_vm.address, "address1", $$v)
                              },
                              expression: "address.address1",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Address Line 2",
                            "label-align": "left",
                          },
                        },
                        [
                          _c("b-input", {
                            model: {
                              value: _vm.address.address2,
                              callback: function ($$v) {
                                _vm.$set(_vm.address, "address2", $$v)
                              },
                              expression: "address.address2",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12", lg: "6" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "City", "label-align": "left" } },
                        [
                          _c("b-input", {
                            model: {
                              value: _vm.address.city,
                              callback: function ($$v) {
                                _vm.$set(_vm.address, "city", $$v)
                              },
                              expression: "address.city",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12", lg: "3" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "State", "label-align": "left" } },
                        [
                          _c("b-input", {
                            attrs: { maxlength: "2" },
                            model: {
                              value: _vm.address.state,
                              callback: function ($$v) {
                                _vm.$set(_vm.address, "state", $$v)
                              },
                              expression: "address.state",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12", lg: "3" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Zipcode", "label-align": "left" } },
                        [
                          _c("b-input", {
                            model: {
                              value: _vm.address.zipcode,
                              callback: function ($$v) {
                                _vm.$set(_vm.address, "zipcode", $$v)
                              },
                              expression: "address.zipcode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.errorMessage
            ? _c("div", { staticClass: "text-danger text-center mt-2" }, [
                _vm._v(_vm._s(_vm.errorMessage)),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            title: "Warning",
            "ok-only": "",
            "ok-title": "Understood",
            "ok-variant": "warning",
          },
          model: {
            value: _vm.warningModal,
            callback: function ($$v) {
              _vm.warningModal = $$v
            },
            expression: "warningModal",
          },
        },
        [
          _vm._v(
            " Please first add user to company to view on the On Boarding page. "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }